import { combineReducers } from 'redux';
import registrationFormsReducer from './RegistrationForms/reducer';
import createRegistrationFormReducer from './CreateRegistrationForm/reducer';
import editRegistrationFormReducer from './EditRegistrationForm/reducer';

const initialState = {
  loading: false,
  error: '',
};

const mainReducer = (state = initialState, {
  type,
}) => {
  switch (type) {
    default:
      return state;
  }
};

const registrationFormReducer = combineReducers({
  main: mainReducer,
  list: registrationFormsReducer,
  create: createRegistrationFormReducer,
  edit: editRegistrationFormReducer,
});

export default registrationFormReducer;
